import classnames from 'classnames/bind'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

type MoreItemProps = {
  className?: string
  text: string
  icon: any
  onClick?: any
}

const MoreItem = (props: MoreItemProps) => {
  const { className, text, icon: Icon, onClick } = props

  return (
    <div className={cx('moreItem', className)} onClick={onClick}>
      <div className={cx('moreItem-icon')}>
        <Icon />
      </div>
      <p className={cx('moreItem-text')}>{text}</p>
    </div>
  )
}

export default MoreItem
